import { useAuth } from '@/lib/auth';

export function usePermissions() {
    const { permissions, identity } = useAuth();

    const hasPermission = (permission: string): boolean => {
        return permissions.includes(permission);
    };

    const hasAllPermissions = (...required: string[]): boolean => {
        return required.every(p => permissions.includes(p));
    };

    const hasAnyPermission = (...required: string[]): boolean => {
        return required.some(p => permissions.includes(p));
    };

    const hasRole = (role: string): boolean => {
        return identity?.roles?.includes(role) ?? false;
    };

    const isPlatformAdmin = identity?.roles?.includes('platform_admin') ?? false;

    return {
        permissions,
        hasPermission,
        hasAllPermissions,
        hasAnyPermission,
        hasRole,
        isPlatformAdmin,
    };
}
